
/* eslint-disable */
export const baseUrl = "/keshav/KeshavReactDemoAdmin/build/"
export const serverUrl = "/keshav/KeshavReactDemoAdmin/build/"
export const webSocketUrl = "http://localhost:8000"
// export const apiUrl = "http://localhost:8000/api"
export const apiUrl = "https://api.reacxle.com/api"

export const postRequest = async (url, body,user=false) => {
    let headers = {}; // Initialize headers object

    const myHeaders = new Headers();
    myHeaders.append("Authorization", user.token);
    if (body instanceof FormData) {
        headers = {};
    } else {
        myHeaders.append("Content-Type", "application/json");
    }

    let requestOptions = {
        method: "POST",
        headers:myHeaders, // Set headers based on body type
        body,
    };
    if (user) {
        requestOptions = {
            method: "POST",
            headers: myHeaders,
            body,
        };
    }
    try {
        const response = await fetch(url,requestOptions);
        const data = await response.json();
        if (!response.ok) {
            let message
            if (data?.message) {
                message = data.message;
            } else {
                message = data;
            }
            return { error: true, message }
        }
        return data
    } catch (error) {
        return { error: true, message:error }
    }
}


export const getRequest = async (url,user=false) => {

    let requestOptions = {};
    if (user) {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", user.token);

        requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
    }
    try {
        const response = await fetch(url,requestOptions);
        const data = await response.json();
        console.log('response',data);
        if (data.error && data.error=="invalid signature") {
            window.location ='/login';
        }
        if (!response.ok) {
            let message = "An error occured"
            if (data?.message) {  
                message = data.message;
            }
            return { error: true, message,code:response.status }
        }
        return data
    } catch (error) {
        return { error: true, message:error }
    }
}




